// PT tree = EN spec tree minus rows with no PT page, plus the PT-only rows from
// today's desktop dropdowns (decisions 17, 18, 19). Labels and hrefs reuse the
// existing PT dropdown data; dropped: Business Solutions, Nonprofit Salary
// Explorer, Volunteer Resources, Volunteer Engagement Resources, Publicar Evento.
import { I18nLocale } from '#/i18n/types/I18nLocale';
import { searchGetEventsPath } from '#/modules/search/events/routing/searchGetEventsPath';
import { searchGetInternshipsPath } from '#/modules/search/internships/routing/searchGetInternshipsPath';
import { searchGetJobsPath } from '#/modules/search/jobs/routing/searchGetJobsPath';
import { searchGetOrgsPath } from '#/modules/search/orgs/routing/searchGetOrgsPath';
import { searchGetVolopsPath } from '#/modules/search/volops/routing/searchGetVolopsPath';
import { SIGN_UP_TO_POST_URL_FOR_LOCALE } from '#/routing/route-constants';
import { createOrgPath, postAListingPath } from '#/routing/routes';

import type { HamburgerMenuData } from './types/HamburgerMenuData';

// CREATE rows with loggedOutHref point to SIGN_UP_TO_POST_URL_FOR_LOCALE when
// there is no user; href is the logged-in target.
export const hamburgerMenuDataPt: HamburgerMenuData = {
  sections: [
    {
      type: 'explore',
      title: 'Explorar',
      rows: [
        {
          // TODO(@paprikka): PT Get Involved uses /pt/movimento (desktop), EN/ES use Idealist Days; discuss /pt/days/participe post-merge, sc-68335
          type: 'get-involved',
          title: 'Participar',
          href: '/pt/movimento',
        },
        {
          type: 'job',
          title: 'Empregos',
          href: searchGetJobsPath({
            locale: I18nLocale.PT,
            embedSearchWidgetId: null,
          }),
        },
        {
          type: 'volop',
          title: 'Voluntariado',
          href: searchGetVolopsPath({
            locale: I18nLocale.PT,
            embedSearchWidgetId: null,
          }),
        },
        {
          type: 'internship',
          title: 'Estágios',
          href: searchGetInternshipsPath({ locale: I18nLocale.PT }),
        },
        {
          type: 'org',
          title: 'Organizações',
          href: searchGetOrgsPath({ locale: I18nLocale.PT }),
        },
        {
          type: 'events',
          title: 'Buscar Evento',
          href: searchGetEventsPath({ locale: I18nLocale.PT }),
        },
        {
          type: 'resources',
          title: 'Recursos',
          rows: [
            {
              type: 'career-advice',
              title: 'Blog Carreira de Impacto',
              href: '/pt/carreira-impacto',
            },
            {
              // desktop points this at /csr-services (wrong); /pt/receitas is the live page (decision 19b)
              type: 'recipes-for-action',
              title: 'Receitas para Ação',
              href: '/pt/receitas?pq=',
            },
            {
              type: 'employer-resources',
              title: 'Recursos para o Recrutador',
              href: '/pt/accion/recursos-org?pq=',
            },
            {
              type: 'blog',
              title: 'Blog Idealista',
              href: '/pt/blog?pq=',
            },
            {
              type: 'idealist-points',
              title: 'Pontos Idealistas',
              href: '/pt/pontos-idealistas',
            },
            {
              type: 'help-center',
              title: 'Central de Atendimento',
              href: '/pt/ajuda',
            },
          ],
        },
      ],
    },
    {
      type: 'create',
      title: 'Anunciar',
      rows: [
        {
          type: 'post-a-listing',
          title: 'Vaga ou Evento',
          href: postAListingPath.with({}),
          loggedOutHref: SIGN_UP_TO_POST_URL_FOR_LOCALE.pt,
        },
        {
          type: 'create-org',
          title: 'Cadastre sua Organização',
          href: createOrgPath.with({}),
          loggedOutHref: SIGN_UP_TO_POST_URL_FOR_LOCALE.pt,
        },
      ],
    },
  ],
  accountSectionTitle: 'Conta',
};
